import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { DriftConfiguration } from '../models/configuration.interface';

export interface Feedback {
  feedback_id: string;
  user_id: string;
  user_email: string;
  user_name: string;
  feedback_text: string;
  created_at: string;
  is_admin: boolean;
}

export enum FeedbackAdvisorType {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE'
}

export interface FeedbackSubmission {
  feedback_text: string;
}

export interface FeedbackResponse {
  message: string;
  feedback_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = this.configurationService.getConfiguration();
  }

  /**
   * Submit feedback from the user
   * @param feedbackText The feedback text to submit
   * @returns Observable with the response containing feedback_id and message
   */
  submitFeedback(feedbackText: string): Observable<FeedbackResponse> {
    const feedback: FeedbackSubmission = {
      feedback_text: feedbackText
    };
    return this.http.post<FeedbackResponse>(`${this.config.driftApi}/feedback`, feedback);
  }

  /**
   * Get all feedback entries (admin only)
   * @returns Observable with array of feedback entries
   */
  getAllFeedback(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>(`${this.config.driftApi}/feedback`);
  }

  /**
   * Get a specific feedback entry by ID (admin only)
   * @param feedbackId The ID of the feedback to retrieve
   * @returns Observable with the feedback entry
   */
  getFeedbackById(feedbackId: string): Observable<Feedback> {
    return this.http.get<Feedback>(`${this.config.driftApi}/feedback/${feedbackId}`);
  }

  /**
   * Delete a feedback entry (admin only)
   * @param feedbackId The ID of the feedback to delete
   * @returns Observable with the deletion response
   */
  deleteFeedback(feedbackId: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.config.driftApi}/feedback/${feedbackId}`);
  }

  /**
   * Submit advisor feedback (thumbs up/down with optional comment)
   * @param feedbackData The advisor feedback data
   * @returns Observable with the response containing message
   */
  // submitAdvisorFeedback(feedbackType: FeedbackAdvisorType): Observable<FeedbackResponse> {
  //   const payload = {
  //     session_id: feedbackData.session_id,
  //     feedback_type: feedbackData.feedback_type,
  //     feedback_text: feedbackData.feedback_text || ''
  //   };
  //   return this.http.post<FeedbackResponse>(`${this.config.driftApi}/feedback/advisor`, payload);
  // }
}
